import { Component } from '@angular/core';
import { GO_URL, TASKS_URL } from 'src/app/config/url.config';

@Component({
  selector: 'storage-alert',
  templateUrl: './storage-alert.component.html',
  styleUrls: ['./storage-alert.component.scss']
})
export class StorageAlertComponent {
  TASKS_URL = GO_URL + "/" + TASKS_URL;
}
